import { NumberInput, SimpleGrid } from "@mantine/core";
import { combineExperience, splitExperience } from "../lib/format";

const EXPERIENCE_FIELD_COLUMNS = { base: 1, xs: 2 } as const;
const EXPERIENCE_FIELD_GAP = "var(--axio-unit-16)";

type Props = {
  value?: number | null;
  onChange: (years: number | undefined) => void;
  disabled?: boolean;
  required?: boolean;
  labelYears?: string;
  labelMonths?: string;
};

export function ExperienceFields({
  value,
  onChange,
  disabled,
  required,
  labelYears = "Years",
  labelMonths = "Months",
}: Props) {
  const parts = value == null ? { years: undefined as number | undefined, months: undefined as number | undefined } : splitExperience(value);
  const years = value == null ? undefined : parts.years;
  const months = value == null ? undefined : parts.months;

  function emit(nextYears?: number, nextMonths?: number) {
    if (nextYears == null && nextMonths == null) {
      onChange(undefined);
      return;
    }
    onChange(combineExperience(nextYears ?? 0, nextMonths ?? 0));
  }

  return (
    <SimpleGrid cols={EXPERIENCE_FIELD_COLUMNS} spacing={EXPERIENCE_FIELD_GAP}>
      <NumberInput
        label={labelYears}
        min={0}
        max={60}
        clampBehavior="strict"
        allowDecimal={false}
        disabled={disabled}
        required={required}
        size="md"
        value={years}
        onChange={(n) => emit(typeof n === "number" ? n : undefined, months)}
      />
      <NumberInput
        label={labelMonths}
        min={0}
        max={11}
        clampBehavior="strict"
        allowDecimal={false}
        disabled={disabled}
        size="md"
        value={months}
        onChange={(n) => emit(years, typeof n === "number" ? n : undefined)}
      />
    </SimpleGrid>
  );
}
